import * as React from 'react';
import { Button } from '@/components/ui/Button';
import { StatusBadge } from './shared/StatusBadge';
import type { Invoice } from '@/types/payment';
import downloadIcon from '@/assets/images/svg/download_dark_icon.svg';

interface InvoiceRowProps {
  invoice: Invoice;
  onDownload: (invoice: Invoice) => void;
}

export const InvoiceRow: React.FC<InvoiceRowProps> = ({ invoice, onDownload }) => {
  const cellClass = 'py-6 px-4 text-left align-middle';
  const textBase = 'font-sans text-18 leading-160 tracking-[-0.02em] text-brand-800';

  return (
    <tr className='border-b border-gray-420 transition-colors last:border-b-0 hover:bg-gray-50/50'>
      {/* Status */}
      <td className={`${cellClass} pl-0`}>
        <StatusBadge status={invoice.status} />
      </td>

      {/* Date */}
      <td className={cellClass}>
        <span className={`whitespace-nowrap font-normal ${textBase}`}>{invoice.date}</span>
      </td>

      {/* Invoice Number */}
      <td className={cellClass}>
        <span
          className={`whitespace-nowrap font-bold ${textBase} underline decoration-solid decoration-auto underline-offset-auto`}
        >
          {invoice.invoiceNumber}
        </span>
      </td>

      {/* Description */}
      <td className={cellClass}>
        <span className={`line-clamp-1 font-normal ${textBase}`}>{invoice.description}</span>
      </td>

      {/* Amount */}
      <td className={cellClass}>
        <span className={`whitespace-nowrap font-bold ${textBase}`}>
          {invoice.amount.toFixed(2)} {invoice.currency}
        </span>
      </td>

      {/* Download Button - Right aligned, no right padding */}
      <td className={`${cellClass} pr-0 text-right`}>
        <div className='inline-block'>
          <Button
            variant='payments-download-row'
            className='h-[41px] w-[144px] gap-2'
            onClick={() => onDownload(invoice)}
            disabled={!invoice.documentAvailable}
          >
            <img src={downloadIcon} alt='' className='size-6' />
            {invoice.documentAvailable ? 'Download' : 'Unavailable'}
          </Button>
        </div>
      </td>
    </tr>
  );
};
